var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"modalWidth":70},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n\t\tPick up History\n\t")]},proxy:true},{key:"body",fn:function(){return [_c('PackingPerStaff',{attrs:{"component_of_modal":true}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }